module.exports = "<ul class=list-state-history> <li class=list-item ng-repeat=\"history in vm.stateHistory\"> <div ng-class=vm.getContext(history.state.code)> {{ history.state.name }} </div> <div class=type-xsmall> {{ history.changedOn | date:'d MMMM yyyy' }} <span class=text-muted>{{ history.changedOn | date:'HH:mm' }}</span> </div> <div class=type-xsmall ng-if=\"history.isSigned !== null\"> <span translate>parcel.isSigned</span> <span class=text-muted>{{ history.isSigned ? ('Yes' | translate) : ('No' | translate) }}</span> </div> </li> </ul>";


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-line-state-history.html
// module id = 550
// module chunks = 0